import {
  DATE_FORMAT,
  formatDate,
  isIsoDate,
} from '../../../../../common/utils';

export const formatConstantDisplayValue = (value: string): string => {
  if (!isIsoDate(value)) {
    return value;
  }

  return formatDate(value, DATE_FORMAT) ?? value;
};
